
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import { getMe } from './services/api';




function App() {
  const [isAuth, setIsAuth]   = useState(false);
  const [user,   setUser]     = useState(null);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const token = localStorage.getItem('monitor_token');
    if (!token) { setLoading(false); return; }

    getMe()
      .then(({ data }) => {
        setUser(data.user);
        setIsAuth(true);
      })
      .catch(() => {
        localStorage.removeItem('monitor_token');
        localStorage.removeItem('monitor_user');
      })
      .finally(() => setLoading(false));
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('monitor_token');
    localStorage.removeItem('monitor_user');
    setIsAuth(false);
    setUser(null);
  };

  if (loading) return null;

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={isAuth
            ? <Navigate to="/dashboard" />
            : <Login setIsAuth={setIsAuth} setUser={setUser} />}
        />
        <Route
          path="/dashboard"
          element={isAuth
            ? <Dashboard user={user} onLogout={handleLogout} />
            : <Navigate to="/" />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;